import { render, staticRenderFns } from "./BSTimer.vue?vue&type=template&id=57be0283"
import script from "./BSTimer.vue?vue&type=script&lang=js"
export * from "./BSTimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports